import { Modal } from "@mui/material";
import React, { useState, useRef, useEffect, useContext } from "react";
import GetEmail from "./GetEmail";
import { QuoteContext } from "./QuoteContext";
import ApiService from "../../services/ApiService";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { DotLoaderComp } from "../../components/DotLoader";
import { MotionConfig } from "framer-motion";
import { motion } from "framer-motion";

// import "jspdf-autotable";

const Summary = () => {
  const { formValues, prevStep, updateFormValues } = useContext(QuoteContext);
  const selectedcardsArray = formValues.selectedPlans;
  const [benefitsData, setBenefitsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [paddingBootom, setPaddingBootom] = useState("0px");
  const [paddingTop, setPaddingTop] = useState("0px");
  const [padingTop, setPadingTop] = useState("0px");
  const contentRef = useRef();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const modalRef = useRef(null);

  // Handle Popup
  const handlePopup = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // Close modal on outside click
  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      closeModal();
    }
  };
  useEffect(() => {
    if (isModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isModalOpen]);

  // Fetch benefits when plans are selected
  useEffect(() => {
    if (selectedcardsArray.length > 0) {
      fetchBenefits(selectedcardsArray.map((card) => card.plan_id));
    }
  }, [selectedcardsArray]);

  // Fetch Benefits API Call
  const fetchBenefits = async (planIds) => {
    try {
      const response = await ApiService.handleGetAllBenefits({
        plans: planIds,
      });
      if (response.success) {
        console.log(response);
        const formattedBenefits = response.data.reduce((acc, item) => {
          acc[item.plan_id] = item.benefits;
          return acc;
        }, {});
        setBenefitsData(formattedBenefits);
      }
    } catch (error) {
      console.error("Error fetching benefits:", error);
    }
  };

  // Generate and Store PDF Using Your Layout
  // const generateAndStorePDF = async () => {
  //   const pdfElement = pdfRef.current;

  //   if (!pdfElement) return;

  //   const canvas = await html2canvas(pdfElement, { scale: 2 });
  //   const imgData = canvas.toDataURL("image/png");

  //   const doc = new jsPDF({ format: "a3" });
  //   const imgWidth = doc.internal.pageSize.getWidth();
  //   const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //   doc.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

  //   // Convert PDF to Blob and Store in Context API
  //   const pdfBlob = doc.output("blob");
  //   const reader = new FileReader();
  //   reader.readAsDataURL(pdfBlob);
  //   reader.onloadend = () => {
  //     const base64data = reader.result.split(",")[1]; // Extract only Base64 content
  //     updateFormValues({ file: base64data }); // Save Base64 PDF in Context
  //   };
  // };

  // const generateAndStorePDF = () => {
  //   setPaddingBootom("20px");
  //   setPaddingTop("2px");
  //   setPadingTop("-2px");

  //   // Hide unnecessary elements during capture
  //   const elementsToHide = document.querySelectorAll(".hide-during-pdf");
  //   const originalDisplay = [];
  //   elementsToHide.forEach((el, index) => {
  //     originalDisplay[index] = el.style.display;
  //     el.style.display = "none";
  //   });

  //   // Store original styles & viewport settings
  //   const originalStyles = {
  //     width: contentRef.current.style.width,
  //     transform: contentRef.current.style.transform,
  //     overflow: document.body.style.overflow,
  //   };

  //   const metaViewport = document.querySelector("meta[name=viewport]");
  //   const originalViewport = metaViewport ? metaViewport.content : "";

  //   // 🔹 Force Desktop Layout
  //   document.body.style.width = "1440px"; // Set full desktop width
  //   document.body.style.transform = "scale(1)";
  //   document.body.style.overflow = "visible"; // Allow full content to be seen
  //   contentRef.current.style.height = "auto"; // Expand height dynamically

  //   if (metaViewport) {
  //     metaViewport.content = "width=1440, initial-scale=1";
  //   }

  //   setTimeout(() => {
  //     const element = contentRef.current;

  //     html2canvas(element, {
  //       scale: 1.2, // Higher scale for quality
  //       useCORS: true,
  //       backgroundColor: "#ffffff",
  //       windowWidth: 1440, // Force full width
  //     }).then((canvas) => {
  //       const imgWidth = 297; // A3 width in mm
  //       const imgHeight = (canvas.height * imgWidth) / canvas.width; // Dynamically adjust height

  //       const pdf = new jsPDF({
  //         orientation: "portrait",
  //         unit: "mm",
  //         format: [imgWidth, imgHeight], // 🔹 Set full height dynamically
  //         compress: true,
  //       });

  //       pdf.addImage(
  //         canvas.toDataURL("image/jpeg", 0.5),
  //         "JPEG",
  //         0,
  //         0,
  //         imgWidth,
  //         imgHeight,
  //         undefined,
  //         "FAST"
  //       );

  //       // Convert PDF to Blob and store in Context API
  //       const pdfBlob = pdf.output("blob");
  //       const reader = new FileReader();
  //       reader.readAsDataURL(pdfBlob);
  //       reader.onloadend = () => {
  //         const base64data = reader.result.split(",")[1];
  //         updateFormValues({ file: base64data });
  //       };

  //       // ✅ Restore UI after PDF generation
  //       elementsToHide.forEach((el, index) => {
  //         el.style.display = originalDisplay[index];
  //       });

  //       // Restore original styles
  //       document.body.style.width = originalStyles.width;
  //       document.body.style.transform = originalStyles.transform;
  //       document.body.style.overflow = originalStyles.overflow;
  //       contentRef.current.style.height = "auto"; // Reset height

  //       // Restore original viewport settings
  //       if (metaViewport) {
  //         metaViewport.content = originalViewport;
  //       }

  //       setTimeout(() => {
  //         setPaddingBootom("0px");
  //         setPadingTop("0px");
  //         setPaddingTop("0px");
  //         window.dispatchEvent(new Event("resize"));
  //         setLoading(false);
  //       }, 50);
  //     });
  //   }, 100);
  // };
  const generateAndStorePDF = () => {
    setPaddingBootom("20px");
    setPaddingTop("2px");
    setPadingTop("-2px");
  
    // Hide unnecessary elements during capture
    const elementsToHide = document.querySelectorAll(".hide-during-pdf");
    const originalDisplay = [];
    elementsToHide.forEach((el, index) => {
      originalDisplay[index] = el.style.display;
      el.style.display = "none";
    });
  
    // ✅ Store original styles only for `contentRef`
    const originalContentStyles = {
      width: contentRef.current.style.width,
      transform: contentRef.current.style.transform,
    };
  
    // ✅ Set only contentRef width, not whole body
    contentRef.current.style.width = "1440px";
    contentRef.current.style.transform = "scale(1)";
    contentRef.current.style.height = "auto";
  
    setTimeout(() => {
      html2canvas(contentRef.current, {
        scale: 1.2,
        useCORS: true,
        backgroundColor: "#ffffff",
        windowWidth: 1440, // Force only content width
      }).then((canvas) => {
        const imgWidth = 297;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: [imgWidth, imgHeight],
          compress: true,
        });
  
        pdf.addImage(
          canvas.toDataURL("image/jpeg", 0.5),
          "JPEG",
          0,
          0,
          imgWidth,
          imgHeight,
          undefined,
          "FAST"
        );
  
        // Convert PDF to Blob and store in Context API
        const pdfBlob = pdf.output("blob");
        const reader = new FileReader();
        reader.readAsDataURL(pdfBlob);
        reader.onloadend = () => {
          const base64data = reader.result.split(",")[1];
          updateFormValues({ file: base64data });
        };
  
        // ✅ Restore original styles only for `contentRef`
        contentRef.current.style.width = originalContentStyles.width;
        contentRef.current.style.transform = originalContentStyles.transform;
        contentRef.current.style.height = "auto";
  
        elementsToHide.forEach((el, index) => {
          el.style.display = originalDisplay[index];
        });
  
        setTimeout(() => {
          setPaddingBootom("4px");
          setPadingTop("0px");
          setPaddingTop("0px");
          window.dispatchEvent(new Event("resize"));
          setLoading(false);
        }, 50);
      });
    }, 100);
  };
  
  const downloadPDF = () => {};

  useEffect(() => {
    if (benefitsData) {
      generateAndStorePDF();
    }
  }, [benefitsData]);

  console.log("benfits", benefitsData);

  return (
    <div className="relative w-full bg-[#022A4A] ">
      {/* Summary will load in background but stay hidden */}
      <div
        className={`absolute inset-0 ${
          loading
            ? "opacity-0 pointer-events-none"
            : "opacity-100 transition-opacity duration-500"
        }`}
      >
        {/* <Summary /> */}
        <div className="p-6 bg-[#022A4A] -z-10">
          <button
            onClick={prevStep}
            className="text-white bg-orangeColor px-2 py-1 rounded mb-2"
          >
            Back
          </button>
          {loading && (
            <div className="absolute inset-0 flex flex-col items-center justify-center bg-gray-800 bg-opacity-50 ">
              {/* <div className="loader border-t-4 border-orangeColor border-solid rounded-full h-12 w-12 animate-spin"></div> */}
              <p className="text-white mt-2">{/* <DotLoaderComp/> */}</p>
            </div>
          )}
          <div
            className="max-w-full mx-auto py-10 bg-white rounded-lg shadow-lg relative"
            ref={contentRef}
          >
            <div className="md:px-10 px-1 ">
              <div className="flex md:flex-row flex-col gap-4 md:gap-0 justify-between py-5">
                <p className="font-bold sm:text-xl text-center text-[#286aa5]">
                  Insurance Quote & Benefits Summary
                </p>
                <div className="flex  justify-center items-center pb-5 gap-5 hide-during-pdf">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    animate={{
                      scale: [1, 1.02, 1], // Creates a pulsing effect
                      opacity: [1, 0.8, 1], // Slight fade effect
                    }}
                    transition={{
                      duration: 1.5, // Animation duration
                      repeat: Infinity, // Infinite loop
                    }}
                    onClick={handlePopup}
                    className="bg-orangeColor py-2 text-white rounded px-3  w-[70%] sm:w-auto max-sm:fixed max-sm:bottom-16 max-sm:right-0 max-sm:w-auto max-sm:py-3 max-sm:rounded-l-full"
                  >
                    Get Email
                  </motion.button>
                  {/* <button
                className="bg-orangeColor py-2 text-white rounded px-3 hidden lg:block"
                onClick={downloadPDF}
              >
                Download
              </button> */}
                </div>
              </div>
              <div className="w-full ">
                {selectedcardsArray.length > 0 ? (
                  <div className=" overflow-x-auto">
                    {/* <button className="">back</button> */}
                    {/* Plans Section */}
                    {/* Plan Section */}
                    {/* <div
                      className="grid min-w-[460px] border-l border-t border-gray-300"
                      style={{
                        gridTemplateColumns:
                          selectedcardsArray.length === 1
                            ? "70% 30%"
                            : `minmax(130px, 1fr) repeat(${selectedcardsArray.length}, 1fr)`,
                      }}
                    > */}
                    <div
                      className={`grid border-l border-t border-gray-300 ${
                        selectedcardsArray.length > 1
                          ? "min-w-[460px]"
                          : "w-auto"
                      }`}
                      style={{
                        gridTemplateColumns:
                          selectedcardsArray.length === 1
                            ? typeof window !== "undefined" &&
                              window.innerWidth < 640
                              ? "50% 50%"
                              : "70% 30%"
                            : `minmax(145px, 1fr) repeat(${selectedcardsArray.length}, 1fr)`,
                      }}
                    >
                      {/* Empty Placeholder for Alignment */}
                      <div className=" xxs:text-[12px] lg:text-[18px] font-poppins font-bold text-black px-2 sm:px-5 my-auto border-gray-300 ">
                        {/* Plan Name */}
                      </div>

                      {/* Plan Name Headers */}
                      {selectedcardsArray.map((card, index) => {
                        const bgColor =
                          index === 0
                            ? "bg-[#A5CBE7]"
                            : index === 1
                            ? "bg-[#286AA5]"
                            : index === 2
                            ? "bg-[#20445E]"
                            : "bg-gray-200"; // Default fallback

                        return (
                          <h2
                            key={card.plan_id || index}
                            className={`font-semibold text-center xxs:text-[12px] px-1 flex justify-center items-center lg:text-[18px] py-4 text-white ${bgColor}`}
                          >
                            {card.plan_name}
                          </h2>
                        );
                      })}

                      {/* Left Labels Column */}
                      <div
                        className="space-y-2 border-t pt-3 pl-4 sm:text-[13px] lg:text-[16px] xxs:text-[11px] text-gray-600 font-medium  border-gray-300"
                        style={{ paddingBottom: `${paddingBootom}` }}
                      >
                        <p>Annual Premium</p>
                        <p>Annual Limit</p>
                        <p>Deductible or Co-Pay</p>
                        <p>Area of Cover</p>
                      </div>

                      {/* Selected Plans Data */}
                      {selectedcardsArray.map((card, index) => (
                        <div
                          key={card.plan_id || index}
                          className="flex flex-col pt-3 space-y-2 border text-gray-800 border-gray-300 px-4 sm:text-[13px] lg:text-[16px] xxs:text-[11px] text-center"
                        >
                          <p className="font-semibold text-[#286aa5]">
                            ${card.total_amount.toLocaleString()}
                          </p>
                          <p>${card.annual_limit.toLocaleString()}</p>
                          <p>{card.deductible_or_copay}</p>
                          {/* <p>{card.area?.name || "N/A"}</p>  */}
                          <div className="flex flex-col">
                            <p>{card.area?.name || "N/A"}</p>
                            {card.area?.name === "Worldwide Ex" && (
                              <p className="text-[10px] text-gray-500 italic">
                                Excluding North and South America, China, Hong
                                Kong, Taiwan, Japan, Singapore, Israel, UAE,
                                Russia, Switzerland, and United Kingdom
                              </p>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Benefits Section */}
                    <div
                      className={`grid border-l border-t border-gray-300 ${
                        selectedcardsArray.length > 1
                          ? "min-w-[460px]"
                          : "w-auto"
                      }`}
                      style={{
                        gridTemplateColumns:
                          selectedcardsArray.length === 1
                            ? typeof window !== "undefined" &&
                              window.innerWidth < 640
                              ? "50% 50%"
                              : "70% 30%"
                            : `minmax(145px, 1fr) repeat(${selectedcardsArray.length}, 1fr)`,
                      }}
                    >
                      {benefitsData &&
                        (() => {
                          const groupedBenefits = Object.values(
                            benefitsData
                          )[0].reduce((acc, benefit) => {
                            if (!acc[benefit.category]) {
                              acc[benefit.category] = [];
                            }
                            acc[benefit.category].push(benefit);
                            return acc;
                          }, {});

                          return Object.entries(groupedBenefits).map(
                            ([category, benefits], idx) => (
                              <React.Fragment key={idx}>
                                {/* Benefit Category Title */}
                                <div
                                  className="col-span-full bg-[#286aa5] text-white text-center xxs:text-[12px] lg:text-[18px] font-semibold"
                                  style={{
                                    paddingBottom: `${paddingBootom}`,
                                    paddingTop: `${padingTop}`,
                                  }}
                                >
                                  <p className="py-2">{category}</p>
                                </div>

                                {/* Benefit Rows */}
                                {benefits.map((benefit, benefitIdx) => (
                                  <React.Fragment key={benefitIdx}>
                                    {/* Left-side Benefit Title */}
                                    <div
                                      className="leading-none pb-1 border border-gray-300 px-4 font-medium text-left sm:text-[13px] lg:text-[16px] xxs:text-[11px]"
                                      style={{
                                        paddingTop: `${paddingTop}`,
                                        paddingBottom: `${paddingBootom}`,
                                      }}
                                    >
                                      <p className="py-2">{benefit.title}</p>
                                      {benefit.subtitle && benefit.subtitle !== "NULL" && (
  <p className="text-[9px] md:text-[11px] text-gray-500 ">
    {benefit.subtitle}
  </p>
)}


                                    </div>

                                    {/* Benefit Data for Selected Plans */}
                                    {selectedcardsArray.map((card) => (
                                      <div
                                        key={card.plan_id}
                                        className="border border-gray-300 flex items-center justify-center  px-4  text-center sm:text-[13px] lg:text-[16px] xxs:text-[11px]"
                                        style={{
                                          paddingTop: `${paddingTop}`,
                                          paddingBottom: `${paddingBootom}`,
                                        }}
                                      >
                                        <p className="py-2">
                                          {benefitsData[card.plan_id]?.find(
                                            (b) => b.title === benefit.title
                                          )?.value || "-"}
                                        </p>
                                      </div>
                                    ))}
                                  </React.Fragment>
                                ))}
                              </React.Fragment>
                            )
                          );
                        })()}
                    </div>
                  </div>
                ) : (
                  <p>No cards selected.</p>
                )}
              </div>
            </div>
            {/* Modal for Email */}
            <Modal
              open={isModalOpen}
              onClose={closeModal}
              aria-labelledby="modal-title"
            >
              <div className="flex items-center justify-center h-full mx-3">
                <div
                  ref={modalRef}
                  className="bg-white rounded-lg shadow-lg p-6"
                >
                  {/* <button
                onClick={closeModal}
                className="absolute top-2 right-2 text-gray-500"
              >
                &times;
              </button> */}
                  <GetEmail closeModal={closeModal} />
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </div>

      {/* Loading screen */}
      {loading && (
        <div className="absolute inset-0">
          <DotLoaderComp />
        </div>
      )}
    </div>
  );
};

export default Summary;
